import React, { useEffect, useState, useContext } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { apiService } from "service/ApiService";
import StoreContext from "contexts/StoreContext";
import DateRangeContext from "contexts/DateRangeContext";
import TableSalesTable from "components/Tables/TableSalesTable";
import { ClipLoader } from "react-spinners";

function TablesStatsPage() {
  const { storeId, setStoreId } = useContext(StoreContext);
  const { dateRange, setDateRange } = useContext(DateRangeContext);
  const [data, setData] = useState({});
  const [showLoader, setShowLoader] = useState(true);

  const refreshData = () => {
    setShowLoader(true);
    apiService
      .post(`api/v1/stores/${storeId}/table-sales`, {
        fromDate: dateRange[0],
        toDate: dateRange[1],
      })
      .then((resp) => {
        formatData(resp);
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        setShowLoader(false);
      });
  };

  const formatData = (tables) => {
    let myData = {};
    for (let table of tables) {
      if (!myData[table.regionId]) {
        myData[table.regionId] = {
          region: table.regionName,
          tables: [],
        };
      }
      myData[table.regionId].tables.push(table);
    }
    setData(myData);
  };

  useEffect(() => {
    if (!storeId || !dateRange) return;
    refreshData();
  }, [storeId, dateRange]);

  return (
    <>
      <Container fluid>
        {showLoader ? (
          <div style={{ textAlign: "center", marginTop: "5vh", marginBottom: "5vh" }}>
            <ClipLoader size={50} color={"#ff6fbc"} />
          </div>
        ) : (
          Object.keys(data).map((key) => (
            <Row key={key}>
              <Col xs={12} md={12}>
                <TableSalesTable regionName={data[key].region} data={data[key].tables} />
              </Col>
            </Row>
          ))
        )}
      </Container>
    </>
  );
}

export default TablesStatsPage;
